<template>
    <b-row class="data-table-row">
        <b-col cols="3" class="mt-1 text-right border-right border-dark data-table-label-column">{{ title }}</b-col>
        <b-col cols="9" class="mt-1">{{ value }}</b-col>
    </b-row>
</template>
<script>
export default {
    props: ['title', 'value'],
}
</script>
<style>
</style>